import { Tab as MuiTab } from "@mui/material";
import styled from "styled-components";

const StyledMuiTab = styled(MuiTab)``;

export const Tab = StyledMuiTab;
